module.exports = __webpack_public_path__ + "static/media/WSUH_1Line_K.0b00f2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/WSUH_1Line_K.png
// module id = 6142
// module chunks = 0